import { isInSettingsGroup, Routes } from 'src/routes';

export const getIsSelectedRoute = (route: Routes, selectedRoute: Routes) => {
  if (route === Routes.Settings) {
    return isInSettingsGroup(selectedRoute);
  }

  return route === selectedRoute;
};
